var _classCallCheck = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\classCallCheck.js");

var _createClass = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\createClass.js");

var _assertThisInitialized = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\assertThisInitialized.js");

var _inherits = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\inherits.js");

var _possibleConstructorReturn = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\possibleConstructorReturn.js");

var _getPrototypeOf = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EventEmitter = require('events');

var parse = require('../parse');

var dev = process.env.NODE_ENV === 'development';
var WebSocket;

var WebSocketConnection = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(WebSocketConnection, _EventEmitter);

  var _super = _createSuper(WebSocketConnection);

  function WebSocketConnection(_WebSocket, url, options) {
    var _this;

    _classCallCheck(this, WebSocketConnection);

    _this = _super.call(this);
    _this.onError = _this.onError.bind(_assertThisInitialized(_this));
    _this.onMessage = _this.onMessage.bind(_assertThisInitialized(_this));
    _this.onOpen = _this.onOpen.bind(_assertThisInitialized(_this));
    _this.onClose = _this.onClose.bind(_assertThisInitialized(_this));
    WebSocket = _WebSocket;
    setTimeout(function () {
      return _this.create(url, options);
    }, 0);
    return _this;
  }

  _createClass(WebSocketConnection, [{
    key: "create",
    value: function create(url, options) {
      if (!WebSocket) this.emit('error', new Error('No WebSocket transport available'));

      try {
        this.socket = new WebSocket(url, [], {
          origin: options.origin
        });
      } catch (e) {
        return this.emit('error', e);
      }

      this.socket.addEventListener('error', this.onError);
      this.socket.addEventListener('open', this.onOpen);
      this.socket.addEventListener('close', this.onClose);
    }
  }, {
    key: "onOpen",
    value: function onOpen() {
      this.emit('connect');
      this.socket.addEventListener('message', this.onMessage);
    }
  }, {
    key: "onMessage",
    value: function onMessage(message) {
      var _this2 = this;

      var data = typeof message.data === 'string' ? message.data : '';
      parse(data, function (err, payloads) {
        if (err) return; //

        payloads.forEach(function (load) {
          if (Array.isArray(load)) {
            load.forEach(function (payload) {
              return _this2.emit('payload', payload);
            });
          } else {
            _this2.emit('payload', load);
          }
        });
      });
    }
  }, {
    key: "onError",
    value: function onError(err) {
      this.emit('error', err);
    }
  }, {
    key: "onClose",
    value: function onClose(e) {
      clearTimeout(this.closeTimeout);
      var err = {
        reason: e ? e.reason : 'unknown',
        code: e ? e.code : 'unknown'
      };

      if (this.socket) {
        this.socket.removeEventListener('open', this.onOpen);
        this.socket.removeEventListener('close', this.onClose);
        this.socket.removeEventListener('message', this.onMessage);
        this.socket.removeEventListener('error', this.onError);
        this.socket = null;
      }

      this.closed = true;
      if (dev) console.log("Closing WebSocket connection, reason: ".concat(err.reason, " (code ").concat(err.code, ")"));
      this.emit('close');
      this.removeAllListeners();
    }
  }, {
    key: "close",
    value: function close() {
      var _this3 = this;

      if (this.socket) {
        this.socket.close(); // give the socket close event some time to fire, otherwise we can clean up
        // and close everything manually

        this.closeTimeout = setTimeout(function () {
          _this3.onClose();
        }, 1000);
      } else {
        this.onClose();
      }
    }
  }, {
    key: "error",
    value: function error(payload, message) {
      var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      this.emit('payload', {
        id: payload.id,
        jsonrpc: payload.jsonrpc,
        error: {
          message: message,
          code: code
        }
      });
    }
  }, {
    key: "send",
    value: function send(payload) {
      var _this4 = this;

      try {
        if (this.socket && this.socket.readyState === this.socket.CONNECTING) {
          setTimeout(function (_) {
            return _this4.send(payload);
          }, 10);
        } else if (!this.socket || this.socket.readyState > 1) {
          this.connected = false;
          this.error(payload, 'Not connected');
        } else {
          this.socket.send(JSON.stringify(payload));
        }
      } catch (e) {
        if (dev) console.error('Error sending Websocket request', e);
        this.error(payload, e.message);
      }
    }
  }]);

  return WebSocketConnection;
}(EventEmitter);

module.exports = function (WebSocket) {
  return function (url, cb) {
    return new WebSocketConnection(WebSocket, url, cb);
  };
};